import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SingleContractInstallment from './singlecontractinstallment';
import {API_URL} from '../config';
import ApiService from '../services/ApiService'; 
// import logo_pop from "../assets/images/logo-pop.png";

var participantBuilding = '';
var participantCity = '';
var participantEmail = '';
var participantFirstName = '';
var participantFlat = '';
var participantLastName = '';
var participantPesel = '';
var participantPhone = '';
var participantPostalCode = '';
var participantStreet = '';

let today = new Date();
let date = today.getDate() + '-' + parseInt(today.getMonth() + 1) + '-' + today.getFullYear();

const App_contract = () => {
    const userGetURL = `${API_URL}UserGet`;
    const apiService = ApiService.getInstance();
    const getPriceByCourseHeadingsIdURL = `${API_URL}GetPriceByCourseHeadingsID`;
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const [formData] = useState({
        coursesHeadingsID: `${localStorage.getItem('coursesHeadingsID')}`,
        startDate: `${localStorage.getItem('startDate')}`,
        current_LocalizationsID: -1,
    });
    const [res, setRes] = useState([]);
    useEffect(() => {
        apiService.apiGet('UserGet', (response) => {

                participantBuilding = response.data.building;
                participantCity = response.data.city;
                participantEmail = response.data.email;
                participantFirstName = response.data.firstName;
                participantFlat = response.data.flat;
                participantLastName = response.data.lastName;
                participantPesel = response.data.pesel;
                participantPhone = response.data.phone;
                participantPostalCode = response.data.postalCode;
                participantStreet = response.data.street;

                axios
                    .post(getPriceByCourseHeadingsIdURL, formData, config)
                    .then((response) => {
                     
                        const prodID = localStorage.getItem('productsID');
                        let data = response.data.body;
                        let item = data.find((e) => Number(e.productsID) === Number(prodID));
                        setRes(item.paymentShedule);
                    })
                    .catch(function (error) {
                        console.log('post error', error);
                    });
            })
            // .catch(function (error) {
            //     console.log('get error response', error);
            // });
    }, []);

    return (
        <>
            <div className="generated-contract">
                <div className="partPdf">
                    {/* <img src={logo_pop} alt="Logo Egurrola Dance Studio" className="generated-contract__logo" /> */}
                    <h1>Umowa uczestnictwa w zajęciach</h1>
                    <h2>HIP HOP, poziom I - wprowadzający</h2>
                </div>

                <div className="partPdf">
                    <p className="generated-contract__intro">
                        zawarta w dniu {date} w {'Miejscowość'} pomiędzy Egurrola Dance Studio –
                        Agustin Marek Egurrola z siedzibą w&nbsp;Warszawie przy ul.&nbsp;Żwirki i
                        Wigury 99a, 02-089 Warszawa, NIP 525-134-00- 26, Regon 0160988446 , zwanym
                        dalej ‘EDS’, a Klientem:
                    </p>
                </div>

                <div className="partPdf">
                    {/* Dane osobowe */}
                    <h3>Dane osobowe</h3>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Imię i nazwisko:</span>
                        <span className="generated-contract__value">
                            {`${participantFirstName}`}&nbsp;{`${participantLastName}`}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Adres:</span>
                        <span className="generated-contract__value">
                            {participantStreet}&nbsp;{participantBuilding}&nbsp;{participantFlat},{' '}
                            {participantPostalCode}&nbsp;{participantCity}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">PESEL:</span>
                        <span className="generated-contract__value">{participantPesel}</span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Telefon:</span>
                        <span className="generated-contract__value">{participantPhone}</span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">E-mail:</span>
                        <span className="generated-contract__value">{participantEmail}</span>
                    </p>
                    <div className="generated-contract__line"></div>
                </div>

                <div className="partPdf">
                    {/* Dane uczestnika */}
                    <h3>
                        Dane uczestnika{' '}
                        <span>
                            (jeżeli inne niż powyżej lub uczestnik jest osobą niepełnoletnią)
                        </span>
                    </h3>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Imię i nazwisko:</span>
                        <span className="generated-contract__value">
                            {localStorage.getItem('relatedFirstName')}&nbsp;
                            {localStorage.getItem('relatedLastName')}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Adres:</span>
                        <span className="generated-contract__value">
                            {localStorage.getItem('relatedStreet')}&nbsp;
                            {localStorage.getItem('relatedBuilding')}&nbsp;
                            {localStorage.getItem('relatedFlat')}
                            {localStorage.getItem('relatedFlat') != null ? ',' : ''}{' '}
                            {localStorage.getItem('relatedPostalCode')}&nbsp;
                            {localStorage.getItem('relatedCity')}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">PESEL:</span>
                        <span className="generated-contract__value">
                            {localStorage.getItem('relatedPesel')}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Telefon:</span>
                        <span className="generated-contract__value">
                            {localStorage.getItem('relatedPhone')}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">E-mail:</span>
                        <span className="generated-contract__value">
                            {localStorage.getItem('relatedEmail')}
                        </span>
                    </p>
                    <div className="generated-contract__line"></div>
                </div>

                <div className="partPdf">
                    {/* Szczegóły umowy */}
                    <h3>Szczegóły umowy</h3>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Rodzaj umowy:</span>
                        <span className="generated-contract__value">
                            {localStorage.getItem('priceListPositionName')}
                        </span>
                    </p>
                    <div className="generated-contract__row--grid">
                        <div>
                            <span className="generated-contract__property">Symbol:</span>
                            <span className="generated-contract__value">
                                {localStorage.getItem('courseHeadingName')}
                            </span>
                        </div>
                        <div>
                            <span className="generated-contract__property">Miejsce zajęć:</span>
                            <span className="generated-contract__value">
                                {localStorage.getItem('localizationName')}
                            </span>
                        </div>
                    </div>
                    <div className="generated-contract__row--grid">
                        <div>
                            <span className="generated-contract__property">Data rozpoczęcia:</span>
                            <span className="generated-contract__value">
                                {localStorage.getItem('startDate')}
                            </span>
                        </div>
                        <div>
                            <span className="generated-contract__property">Data zakończenia:</span>
                            <span className="generated-contract__value">
                                {localStorage.getItem('expirationDateTo')}
                            </span>
                        </div>
                    </div>
                    <div className="generated-contract__row--grid">
                        <div>
                            <span className="generated-contract__property">Długość zajęć:</span>
                            <span className="generated-contract__value">
                                {localStorage.getItem('DurationMin')} min.
                            </span>
                        </div>
                        <div>
                            <span className="generated-contract__property">
                                Ilość zajęć w tygodniu:
                            </span>
                            <span className="generated-contract__value">
                                {localStorage.getItem('Frequency')}
                            </span>
                        </div>
                    </div>
                    <div className="generated-contract__line"></div>
                </div>

                <div className="partPdf">
                    {/* Szczegóły płatności */}
                    <h3>Szczegóły płatności</h3>
                    <div className="generated-contract__row--grid">
                        <div>
                            <span className="generated-contract__property">Koszt kursu:</span>
                            <span className="generated-contract__value">
                                {localStorage.getItem('amount')} zł
                            </span>
                        </div>
                        <div>
                            <span className="generated-contract__property">
                                Wartość raty zero (pro-raty):
                            </span>
                            <span className="generated-contract__value">
                                {localStorage.getItem('paymentPositionPrice')} zł
                            </span>
                        </div>
                    </div>
                    <div className="generated-contract__row--grid">
                        <div>
                            <span className="generated-contract__property">Płatność:</span>
                            <span className="generated-contract__value">
                                {localStorage.getItem('payment')}
                            </span>
                        </div>
                        <div>
                            <span className="generated-contract__property">Opłata wpisowa:</span>
                            <span className="generated-contract__value"></span>
                        </div>
                    </div>
                    <div className="generated-contract__row--grid">
                        <div>
                            <span className="generated-contract__property">
                                Liczba pełnych rat:
                            </span>
                            <span className="generated-contract__value">
                                {localStorage.getItem('amount') /
                                    localStorage.getItem('paymentPositionPrice')}
                            </span>
                        </div>
                        <div>
                            <span className="generated-contract__property">
                                Suma opłat początkowych:
                            </span>
                            <span className="generated-contract__value">
                                {localStorage.getItem('suma')} zł
                            </span>
                        </div>
                    </div>
                </div>

                <div className="partPdf">
                    {/* Table caption */}
                    <p className="generated-contract__row generated-contract__table-caption">
                        Wartość rat miesięcznych:
                    </p>
                    {/* Table */}
                    <table className="generated-contract__table">
                        <thead>
                            <tr>
                                <th>Nr raty</th>
                                <th>Kwota</th>
                                {/* <th>Miesiąc raty</th> */}
                                <th>Termin płatności</th>
                            </tr>
                        </thead>
                        <tbody>
                            {res.map((el) => (
                                <SingleContractInstallment
                                    key={el.countNumber}
                                    countNumber={el.countNumber}
                                    paymentPositionPrice={el.paymentPositionPrice}
                                    paymentMonth={el.paymentMonth}
                                    paymentDate={el.paymentDate}
                                />
                            ))}
                            {/* <SingleContractInstallment key={1} countNumber={1} paymentPositionPrice={222} paymentMonth={"wrzesień"} paymentDate={"2021-09-12"} />
                            <SingleContractInstallment key={1} countNumber={1} paymentPositionPrice={222} paymentMonth={"wrzesień"} paymentDate={"2021-09-12"} />
                            <SingleContractInstallment key={1} countNumber={1} paymentPositionPrice={222} paymentMonth={"wrzesień"} paymentDate={"2021-09-12"} />
                            <SingleContractInstallment key={1} countNumber={1} paymentPositionPrice={222} paymentMonth={"wrzesień"} paymentDate={"2021-09-12"} /> */}
                        </tbody>
                    </table>
                </div>

                {/* Dalsza treść umowy */}
                <div className="generated-contract__clauses">
                    <div className="partPdf">
                        <h3>1. Postanowienia ogólne</h3>
                        <p>
                            1.1. Integralną częścią niniejszej Umowy jest Regulamin oraz Statut EDS
                            , które są dostępne w placówce EDS.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            1.2. Wszelkie pojęcia zawarte w niniejszej Umowie mają znaczenie nadane
                            im przez Regulamin.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            1.3. Klient oświadcza, że nie istnieją żadne przeciwwskazania, w tym
                            zdrowotne, do uczestnictwa w zajęciach Grupy będącej przedmiotem
                            niniejszej Umowy.
                        </p>
                    </div>

                    <div className="partPdf">
                        <h3>2. Przedmiot umowy</h3>
                        <p>
                            2.1. EDS zobowiązuje się świadczyć na rzecz Uczestnika usługi nauki
                            tańca oraz\lub nauki choreografii zgodnie z&nbsp;celami i zadaniami
                            zawartymi w Statucie na zajęciach prowadzonych w Grupie zgodnie z
                            programem EDS oraz postanowieniami niniejszej Umowy.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            2.2. Zajęcia Grupy będące przedmiotem Umowy są prowadzone zgodnie z
                            harmonogramem dostępnym w placówce EDS.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            2.3. Za zgodą EDS Uczestnik może zmienić Grupę w trakcie obowiązywania
                            Umowy na inną z oferty zajęć regularnych o&nbsp;tej samej długości i
                            częstotliwości, pod warunkiem dostępności miejsca w danej Grupie. Po
                            potwierdzeniu dostępności miejsca w innej Grupie Uczestnik zobowiązany
                            jest złożyć w recepcji EDS osobiście podpisany formularz aktualizacji
                            danych. Zmiana grupy nie wymaga zmiany umowy w trybie punktu 5.2.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            2.4. Strony przewidują możliwość odrabiania Zajęć w ciągu 30 dni od daty
                            Zajęć, w których Uczeń nie mógł uczestniczyć, na innych z oferty
                            otwartych zajęć regularnych, o&nbsp;tej samej długości i częstotliwości,
                            pod warunkiem dostępności miejsca w danej grupie i po uprzedniej
                            akceptacji Managera EDS.
                        </p>
                    </div>

                    <div className="partPdf">
                        <h3>3. Czas trwania umowy</h3>
                        <p>
                            3.1. Umowa zostaje zawarta na czas określony do dnia zakończenia umowy
                            wskazanej w części wstępnej.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            3.2. Klient ma prawo rozwiązania niniejszej Umowy w dowolnym momencie z
                            zachowaniem dwumiesięcznego okresu wypowiedzenia ze skutkiem na koniec
                            miesiąca kalendarzowego. Oświadczenie o wypowiedzeniu należy złożyć
                            w&nbsp;formie pisemnej osobiście w placówce EDS lub drogą pocztową
                            (liczy się data stempla pocztowego). Umowa ulega rozwiązaniu po upływie
                            ostatniego dnia wypowiedzenia.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            3.3. Klientowi, który wypowiedział Umowę przysługuje w terminie 14 dni
                            od dnia zakończenia Umowy zwrot uiszczonych Opłat pozostałych do końca
                            okresu, do którego miała trwać Umowa.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            3.4. W przypadku nie przestrzegania zapisów Regulaminu orazStatusu , EDS
                            może rozwiązać Umowę ze skutkiem natychmiastowym. Rozwiązanie umowy jest
                            jednoznaczne ze skreśleniem Uczestnika z listy uczniów EDS.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            3.5. Od decyzji w przedmiocie skreślenia z listy uczniów można wnieść
                            odwołanie do organu prowadzącego placówkę EDS na zasadach i w trybie
                            określonym w Statucie.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            3.6. W zakresie rozliczeń związanych z rozwiązaniem Umowy stosuje się
                            odpowiednio zasady określone w&nbsp;Regulaminie.
                        </p>
                    </div>

                    <div className="partPdf">
                        <h3>4. Opłaty</h3>
                        <p>
                            4.1. Klient zobowiązuje się do opłacania rat oraz innych opłat w
                            wysokości i terminach określonych w niniejszej Umowie.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.2. Jednorazową opłatę wpisową oraz pro ratę należy uiścić przed
                            rozpoczęciem zajęć.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.3. Klient może wnosić opłaty w następujący sposób: przedpłatą za
                            całość kursu, w terminie do 5 dnia miesiąca, w&nbsp;którym zaczynają się
                            zajęcia Grupy, jednak nie później niż w dniu a) rozpoczęcia zajęć Grupy,
                            w formie miesięcznych rat płatnych do 5 dnia każdego kolejnego miesiąca
                            obowiązywania umowy począwszy od pierwszego b) miesiąca zajęć Grupy,
                            jednak nie później niż w dniu rozpoczęcia zajęć Grupy w danym miesiącu.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.4. Pro-rata jest ustalana w wysokości proporcjonalnej do liczby zajęć
                            Grupy w pierwszym miesiącu kalendarzowym trwania umowy.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.5. Terminowe dokonanie płatności jest warunkiem uczestnictwa w
                            zajęciach Grupy.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.6. Wysokość raty wyliczana jest na podstawie całkowitej wartości kursu
                            oraz miesięcy pozostających do jego zakończenia. Jest ona stała przez
                            cały okres umowy, niezależnie od ilości zajęć Grupy w danym miesiącu.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.7. W przypadku płatności przelewem tradycyjnym lub płatnościami
                            on-line dniem dokonania płatności jest data uznania rachunku bankowego
                            EDS.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.8. Płatności przelewem należy wykonywać na rachunek bankowy: 03 2490
                            0005 0000 4600 7905 8282.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.9. W tytule należy podać imię i nazwisko uczestnika oraz symbol Grupy,
                            za które opłata jest wnoszona.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.10. Szczegółowe formy płatności akceptowane przez EDS określone są w
                            Regulaminie W okresie wypowiedzenia Klient ma obowiązek regulowania
                            wszystkich należnych rat oraz opłat zgodnie z zapisami niniejszej umowy.
                        </p>
                    </div>

                    <div className="partPdf">
                        <h3>5. Prawo do odstąpienia</h3>
                        <p>
                            5.1. Zawarcie przez klienta Umowy za pośrednictwem sieci Internet
                            (on-line) jest traktowane jako zawarcie umowy na odległość w rozumieniu
                            przepisów ustawy z dnia 24 czerwca 2014 roku o prawach konsumenta (Dz.
                            U. poz. 827).
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            5.2. Klientowi, który zawarł Umowę w sposób o którym mowa w ust. 5.1.
                            powyżej przysługuje prawo odstąpienia od Umowy, które winien wykonać w
                            terminie 14 (słownie: czternastu) dni od dnia zawarcia Umowy.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            5.3. Prawo odstąpienia od Umowy wykonywane jest poprzez złożenie przez
                            Członka Klubu pisemnego oświadczenia o odstąpieniu od Umowy.
                            Oświadczenie w formie pisemnej winno zawierać co najmniej następujące
                            elementy:
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>a) oznaczenie Placówki Egurrola Dance Studio,</p>
                    </div>

                    <div className="partPdf">
                        <p>b) oznaczenie Uczestnika zajęć,</p>
                    </div>

                    <div className="partPdf">
                        <p>c) data,</p>
                    </div>

                    <div className="partPdf">
                        <p>
                            d) oświadczenie o odstąpieniu o treści: „Ja (imię i nazwisko) niniejszym
                            informuję o moim odstąpieniu od umowy (nazwa umowy) o uczestnictwo w
                            zajęciach grupowych (nazwa, adres) zawartej dnia (data)” – lub
                            równoważnej.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            5.4. W przypadku skutecznego skorzystania z prawa odstąpienia od Umowy
                            wskazanego w punkcie 5.1. powyżej, Klientowi przysługuje w terminie 14
                            (słownie: czternastu) dni od dnia otrzymania oświadczenia o odstąpieniu
                            od Umowy zwrot opłat uiszczonych przez Klienta przy zawarciu Umowy, na
                            rachunek bankowy, z którego opłata została dokonana.
                        </p>
                    </div>

                    <div className="partPdf">
                        <h3>6. Postanowienia końcowe</h3>
                        <p>
                            6.1. Niniejsza Umowa została sporządzona w dwóch, jednobrzmiących
                            egzemplarzach, po jednym dla każdej ze Stron.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            6.2. Zmiana niniejszej Umowy wymaga zachowania formy pisemnej pod
                            rygorem nieważności.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>6.3. Umowa zostaje zawarta z dniem podpisania przez obie Strony.</p>
                    </div>

                    <div className="partPdf">
                        <h3>7. Klauzula informacyjna RODO</h3>
                        <p>
                            7.1. Informujemy, że Administratorem Danych Osobowych jest EGURROLA
                            DANCE STUDIO z siedzibą w&nbsp;Warszawie&nbsp;(02&#8209;089), Żwirki i
                            Wigury 99a, NIP 525-134-00-26, e-mail: studio@egurrola.pl. Dane
                            kontaktowe Inspektora Ochrony Danych są tożsame z danymi kontaktowymi
                            Administratora wskazanymi w zdaniu poprzednim.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            7.2. Dane osobowe będą przetwarzane w celach wykonywania zawartej umowy
                            cywilno-prawnej oraz zgodnie z treścią udzielonych Administratorowi
                            zgód. Podstawą prawną przetwarzania są czynności związane z wykonaniem
                            umowy, wypełnienie obowiązku prawnego ciążącego na Administratorze
                            wynikającego z przepisów administracyjnych oraz zgoda osoby, której dane
                            dotyczą. Podanie danych jest obowiązkiem wynikającym z przepisów
                            administracyjnych, a&nbsp;ich nie podanie będzie skutkowało nie
                            zawarciem umowy. Odbiorcami danych osobowych są uprawnione organy
                            publiczne.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            7.3. Dane będą przetwarzane w okresie 10 lat (przedawnienie roszczeń),
                            do czasu, w którym ustanie cel dla którego zostały zebrane oraz zgodnie
                            z terminami wskazanymi w przepisach administracyjnych, w zależności co
                            nastąpi później. Każdy ma prawo żądania od Administratora dostępu do
                            danych osobowych, ich sprostowania, usunięcia, ograniczenia
                            przetwarzania, a także prawo do przenoszenia danych. Każdy ma prawo do
                            cofnięcia zgody na przetwarzanie danych osobowych, którą udzielił
                            Administratorowi. Wycofanie zgody nie ma wpływu na zgodność
                            z&nbsp;prawem przetwarzania, którego dokonano przed jej cofnięciem.
                            Każdy ma prawo do wniesienia skargi do Organu Nadzorczego (po 25 maja
                            2018 r.: do Prezesa Urzędu Ochrony Danych Osobowych).
                        </p>
                    </div>
                </div>

                <div className="partPdf">
                    {/* Agreement */}
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__text">
                            <p>
                                Wyrażam zgodę na otrzymywanie informacji marketingowych i handlowych
                                drogą elektroniczną, za pośrednictwem automatycznych systemów
                                wywołujących oraz telefonicznie z wykorzystaniem telekomunikacyjnych
                                urządzeń końcowych.
                            </p>
                            <p>
                                Podpis Klienta Wyrażam zgodę na przetwarzanie moich danych osobowych
                                w celach marketingowych promujących towary i usługi Administratora,
                                a także w celach promujących towary i usługi podmiotów z Grupy EDS.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="partPdf">
                    {/* Agreement */}
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__signatures">
                            <div className="generated-contract__signature">
                                <span>Data i podpis w imieniu EDS</span>
                            </div>
                            <div className="generated-contract__signature">
                                <span>Data i podpis Klienta</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="partPdf">
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__text">
                            Wyrażam zgodę na otrzymywanie informacji marketingowych i handlowych
                            drogą elektroniczną, za pośrednictwem automatycznych systemów
                            wywołujących oraz telefonicznie z wykorzystaniem telekomunikacyjnych
                            urządzeń końcowych.
                        </div>
                    </div>
                </div>
                <div className="partPdf">
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__signature--only-client">
                            <div className="generated-contract__signature">
                                <span>Podpis Klienta</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="partPdf">
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__text">
                            Wyrażam zgodę na przetwarzanie moich danych osobowych w celach
                            marketingowych promujących towary i usługi Administratora, a także w
                            celach promujących towary i usługi podmiotów z Grupy EDS.
                        </div>
                    </div>
                </div>

                <div className="partPdf">
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__signature--only-client">
                            <div className="generated-contract__signature">
                                <span>Podpis Klienta</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default App_contract;
